import { combineReducers } from 'redux';

import Auth from './auth/reducers';
import Layout from './layout/reducers';
import PageTitle from './pageTitle/reducers';
import Test from './test/reducers';
import TestCategory from './testCategory/reducers';
import Panel from './panel/reducers';
import PanelCategory from './panelCategory/reducers';
import Employee from './employee/reducers';
import LetterHead from './letterHead/reducers';
import LabRegistration from './labRegistration/reducers';
import LabMemberShip from './labMemberShip/reducers';
import ContactPerson from './contactPerson/reducers';
import User from './user/reducers';
import TestRateCard from './testRateCard/reducers';
import PanelRateCard from './panelRateCard/reducers';
import DiscountCoupon from './discountCoupon/reducers';
import Dashboard from './dashboard/reducers';
import Patient from './patient/reducers';
import Encounter from './encounter/reducers';
import CredExpInfo from './credExpInfo/reducers';
import Notify from './notify/reducers';
import Report from './report/reducers';
import TestParamMapping from './testParamMapping/reducers';
import TestPanelMapping from './testPanelMapping/reducers';
import RangeDef from './rangeDef/reducers';
import ResultSet from './resultSet/reducers';
import UOM from './unitOfMeasurement/reducers';
import ResetPassword from './resetPassword/reducers';
import Observation from './observation/reducers';
import Designation from './designation/reducers';
import AssociatedList from './associatedList/reducers';
import Import from './import/reducers';
import OPDService from './opdServices/reducers';
import LabSubCenter from './labSubCenter/reducers';
import SideBarMenu from './sidebarMenu/reducers';
import Department from './department/reducers';
export default combineReducers({
    Auth,
    Layout,
    PageTitle,
    Test,
    TestCategory,
    Panel,
    PanelCategory,
    Employee,
    LetterHead,
    LabRegistration,
    LabMemberShip,
    ContactPerson,
    User,
    TestRateCard,
    PanelRateCard,
    DiscountCoupon,
    Dashboard,
    Patient,
    Encounter,
    CredExpInfo,
    Notify,
    Report,
    TestParamMapping,
    TestPanelMapping,
    RangeDef,
    ResultSet,
    UOM,
    ResetPassword,
    Observation,
    Designation,
    AssociatedList,
    Import,
    OPDService,
    LabSubCenter,
    SideBarMenu,
    Department,
});
